import React, {useState} from 'react';
import { Helmet } from 'react-helmet';
import drimage from "./../../../assets/images/sir.png";
import OtherPageBookingModel from "./../../AppointmentBookingFormOtherPage";

const AboutDR = () => {
	
	const [showpagebookingmodal, setShowPageBookingModal] = useState(false);
	
	const handleOtherPageBookingModelOpen = () =>{
		setShowPageBookingModal(true);
	}
	const handleOtherPageBookingModelClose = () =>{
		setShowPageBookingModal(false);
	}
	
  return (
    <section className="about-us">
		<div className="container">
			<div className="row">
				<div className="col-xl-6 pe-xl-5">
					<img src={drimage} style={{ width: "50%" }} className="img-fluid wow fadeInLeft" alt="Dr. (Major) Rajesh Bhardwaj" />
				</div>
				<div className="col-xl-6 px-xl-4 mt-4 mt-xl-0">
					<div className="pq-section pq-style-1 text-left">
						<span className="pq-section-sub-title">About the Doctor</span>
						<h1 className="pq-section-title">Dr. (Major) Rajesh Bhardwaj</h1>
						<p className="pq-section-description"> MBBS (AFMC), MS, DNB, DLO, DHA </p>
						
						<p className="pq-section-description"> Dr. (Major) Bhardwaj graduated from Armed Forces Medical College (AFMC), Pune in 1982 and served in the Indian Army for 15 years, where he gained vast clinical experience as an ENT specialist. He has served in the largest and busiest hospitals of the armed forces including Command Hospitals at Pune and Chandigarh and at the Army Hospital (R&R), Delhi Cantt.
						</p>
						
						<p className="pq-section-description"> Dr. Bhardwaj earned his blue and white striped Siachen Glacier Medal for his long stint on the Siachen glacier in 1984 and was the first medical officer to complete his tour of duty without being medically evacuated. He has also served at Jaffna (Sri Lanka) during the peacekeeping mission and was in charge of the battle casualty ward, where his skill as a surgeon and hardiness of a soldier were put to the test while handling many casualties on a daily basis.
						</p>
					</div>
					
					<div className="">
						<button type="button" className="btn btn-primary btn-lg mt-3 rounded-pill px-4" style={{ backgroundColor: "rgb(40, 167, 69)", borderColor: "rgb(40, 167, 69)", fontWeight: "600", boxShadow: "rgba(40, 167, 69, 0.4) 0px 4px 15px", borderRadius: "50rem" }} name="btnbookappointment" id="btnbookappointment" onClick={handleOtherPageBookingModelOpen} aria-label="Open enquiry form">Book an Appointment</button>
					</div>

					<OtherPageBookingModel showBookingModel={showpagebookingmodal} onBookingModelClose={handleOtherPageBookingModelClose} />
				
				</div>
			</div>
		</div>
    </section>
  );
};

export default AboutDR;
